<template>
  <pt-system-customer-form class="pt-customer-manage-form__page" :isEdit="is_edit" :userLogin="userLogin"></pt-system-customer-form>
</template>

<script>
import ptSystemCustomerForm from 'cps/customer-manage/pt-customer-of-system/pt-system-customer-form'
export default {
  name: 'pt-system-customer-form__view',
  components: {
    'pt-system-customer-form': ptSystemCustomerForm
  },
  props: {
    isEdit: {
      type: String,
      default: ''
    },
    userLogin: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      is_edit: this.isEdit === 'true'
    }
  }
}
</script>
